import {
  GET_REINFORCEMENTS,
  GET_REINFORCEMENTS_LIST,
  GET_REINFORCEMENTS_MINIMAL,
  GET_REINFORCEMENT,
  ADD_REINFORCEMENT,
  DELETE_REINFORCEMENT,
  UPDATE_REINFORCEMENT,
  REINFORCEMENTS_LOADING,
  REINFORCEMENT_LOADING,
  CLEAR_CURRENT_REINFORCEMENT,
  SET_REINFORCEMENTS_PAGE
} from '../actions/types';

const initialState = {
  reinforcements: [],           // Lightweight list for table
  minimalReinforcements: [],    // Ultra-lightweight list for dropdowns (only _id and title)
  currentReinforcement: null,   // Full reinforcement data for view/edit pages
  loading: false,               // For list loading
  reinforcementLoading: false,  // For single reinforcement loading
  currentPage: 1,               // Current page number
  totalPages: 0,                // Total number of pages
  totalReinforcements: 0,       // Total number of reinforcements
  hasNextPage: false,           // Whether there's a next page
  hasPrevPage: false            // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_REINFORCEMENTS_MINIMAL:
      return {
        ...state,
        minimalReinforcements: action.payload,
        loading: false
      };

    case GET_REINFORCEMENTS_LIST:
      return {
        ...state,
        reinforcements: action.payload.reinforcements || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalReinforcements: action.payload.totalReinforcements || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_REINFORCEMENT:
      return {
        ...state,
        currentReinforcement: action.payload,
        reinforcementLoading: false
      };

    case REINFORCEMENT_LOADING:
      return { ...state, reinforcementLoading: true };

    case CLEAR_CURRENT_REINFORCEMENT:
      return { ...state, currentReinforcement: null, reinforcementLoading: false };

    case ADD_REINFORCEMENT:
      return {
        ...state,
        // Add lightweight version to list
        reinforcements: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            tags: action.payload.tags,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.reinforcements
        ],
        currentReinforcement: action.payload
      };

    case UPDATE_REINFORCEMENT:
      return {
        ...state,
        // Update in list
        reinforcements: state.reinforcements.map(reinforcement =>
          reinforcement._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                tags: action.payload.tags,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : reinforcement
        ),
        currentReinforcement: action.payload
      };

    case DELETE_REINFORCEMENT:
      return {
        ...state,
        reinforcements: state.reinforcements.filter(reinforcement => reinforcement._id !== action.payload),
        currentReinforcement: null
      };

    case REINFORCEMENTS_LOADING:
      return { ...state, loading: true };

    case GET_REINFORCEMENTS: // Keep for backward compatibility
      return { ...state, reinforcements: action.payload, loading: false };

    case SET_REINFORCEMENTS_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
}